import React, { Component } from 'react'
import s from './style.scss'
import classnames from 'classnames'

class Dropdown extends Component {

	constructor(props) {
		super(props)

		console.log('DROPDOWN STATE')

		this.state = {
			selection: props.options && props.options.length ? props.options[0].value : '',
			hide: true
		}
	}

	// componentDidMount() {
	// 	if (this.state.selection && this.state.selection.length > 0 && this.props.onSelect)
	// 		this.props.onSelect(this.state.selection)
	// }

	render() {

		const { label, onSelect, options, top, hidden, children } = this.props
		const { selection, hide } = this.state

		return <div className={classnames(s.container)}>
			
			{label && <div className={s.label} onClick={() => this.setState({ hide: !hide })}>{label}</div>}

			{children}

			{(!hide || hidden === false) && options && options.length > 0 && <div className={classnames(s.dropdown, top && s.top)}>
				{options.map(({ label, value }, key) => <div className={classnames(s.option, selection === value && s.active)} key={key} onClick={() => {
					this.setState({ selection: value, hide: true })
					onSelect(value)
				}}>
					{label}
				</div>)}
			</div>}
			
		</div>
	}
}

export default Dropdown


// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js